import { render, staticRenderFns } from "./DeadlineAlert.vue?vue&type=template&id=917cdcba"
import script from "./DeadlineAlert.vue?vue&type=script&lang=js"
export * from "./DeadlineAlert.vue?vue&type=script&lang=js"
import style0 from "./DeadlineAlert.vue?vue&type=style&index=0&id=917cdcba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports